import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ApiError, AuthService, MessageService } from '../../../../core';
import { AtividadeFilterVisibilidade, visibilidades, isVisibilidadeMinhas } from './atividade-filter-visibilidade';
import { UsuarioCrudHttpService, UsuarioFilter, usuarioAtivo } from '../../../usuario';


@Component({
    selector: 'sgt-atividade-filter-visibilidade',
    templateUrl: './atividade-filter-visibilidade.component.html',
    styleUrls: ['./atividade-filter-visibilidade.component.less']
})
export class AtividadeFilterVisibilidadeComponent implements OnInit {
    isAdministrador: boolean;
    isGerente: boolean;
    isAtendente: boolean;

    visibilidadesDisponiveis = visibilidades;

    @Input() visibilidade: number;
    @Output() visibilidadeChange = new EventEmitter<number>();

    @Input() idsUsuariosDestino: number[] = [];
    @Output() idsUsuariosDestinoChange = new EventEmitter<number[]>();

    // Multiselect dos usuários
    isFirstChangeUsuariosDestino: boolean;
    multiselectUsuariosDestinoOptions: IMultiSelectOption[];
    multiselectUsuariosDestinoSettings: IMultiSelectSettings = {
        enableSearch: true,
        containerClasses: 'container-multiselect',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 0,
    }
    multiselectUsuariosDestinoTexts: IMultiSelectTexts = {
        checkAll: 'Todos',
        uncheckAll: 'Nenhum',
        checked: 'responsável',
        checkedPlural: 'responsáveis',
        searchPlaceholder: 'Pesquisar...',
        defaultTitle: 'Nenhum responsável',
        allSelected: 'Todos selecionados',
        searchEmptyResult: 'Nenhum responsável encontrado',
        searchNoRenderText: 'Digite para pesquisar'
    }

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private usuarioCrudHttpService: UsuarioCrudHttpService) { }

    ngOnInit(): void {
        this.isAdministrador = this.authService.isAdministrador();
        this.isGerente = this.authService.isGerente();
        this.isAtendente = this.authService.isAtendente();

        this.isFirstChangeUsuariosDestino = !isVisibilidadeMinhas(this.visibilidade);
        this.searchUsuariosDestino();
    }

    selectVisibilidade(visibilidadeSelected: AtividadeFilterVisibilidade) {
        this.visibilidade = visibilidadeSelected.id;
        this.visibilidadeChange.emit(this.visibilidade);
    }

    /** Verifica se é para exibir a opção de selecionar os usuários responsáveis */
    isShowUsuariosDestino(): boolean {
        // Se for a visibilidade de minhas atividades não precisa exibir o multiselect para selecionar os responsáveis
        if (isVisibilidadeMinhas(this.visibilidade)) {
            return false;
        }

        return this.isAdministrador || this.isGerente || this.isAtendente;
    }

    /** Pesquisa todos os usuários cadastrados */
    private searchUsuariosDestino() {
        this.multiselectUsuariosDestinoOptions = [];

        const filter = new UsuarioFilter();
        filter.situacao = usuarioAtivo.id;
        this.usuarioCrudHttpService.searchWithFilter(filter, null, null, null, 1, 'asc')
            .subscribe(
                response => {
                    // Adicionando os usuarios ao multiselect
                    if (response && response.data) {
                        const selects: IMultiSelectOption[] = [];
                        response.data.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.multiselectUsuariosDestinoOptions = selects;
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os usuários cadastrados', error)
            );
    }

    onChangeUsuariosDestino() {
        if (this.isFirstChangeUsuariosDestino) {
            this.isFirstChangeUsuariosDestino = false;
            return;
        }

        this.idsUsuariosDestinoChange.emit(this.idsUsuariosDestino);
    }
}
